@if (tenantStore.id()) {
  <shared-form-header [formTitle]="tenantStore.name()">
    <div class="form-content" form-content>
      @let errors = resetPasswordErrors();
      <div class="error-wrapper">
        @for (error of errors; track error.id) {
          <orbit-message
            [message]="error.message ?? error.code | translate"
            [severity]="'error'"
            [titleTestId]="'error-reset-password-title-' + error.id"
            [messageTestId]="'error-reset-password-message-' + error.id" />
        }
      </div>
      <shared-reset-password-form (resetPasswordAttempt)="resetPassword($event)" />
    </div>
  </shared-form-header>
} @else {
  @let errors = tenantErrors();
  @if (errors && errors.length > 0 && errors[0]) {
    @let error = errors[0];
    <shared-global-error
      [message]="error.message ?? error.code | translate"
      [unknownError]="false"
      [hasReload]="false" />
  } @else {
    <orbit-fa-icon class="loading-icon" [iconName]="spinnerIcon" animation="spin" iconSize="2x" />
  }
}
